/* eslint-disable */
import React, { Component } from 'react';
import './style.less';
import { Row, Col, Button, notification, } from 'antd';
import { NewsDetailDataSource } from "../../common/globalDataList";

export default class index extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
        if (sessionStorage.newDetailIx && sessionStorage.newsList) {
            window.location.href = "/#/news3?k=" + sessionStorage.newDetailIx;
        }
    }

    componentWillReceiveProps(nextProps) {

    }
    goBackClick() {
        window.history.go(-1)
    }
    changeInfo(add, e) {
        let ix = parseInt(sessionStorage.newDetailIx);
        if (ix === 0 && add === -1) {
            notification.warning({ message: "当前已是第一页!" });
        } else if (ix === window.newsList.length - 1 && add === 1) {
            notification.warning({ message: "当前已是最后一页!" });
        } else {
            ix = parseInt(ix) + add;
            sessionStorage.newDetailIx = ix;
            window.location.href = "/#/news3?k=" + ix;
        }
    }

    render() {
        const { title, textList, feTitle, imgList, preInfo, fixInfo, videoUrl, } = this.props;
        console.log("送到家", this.props);

        return (
            <div className={"textCon"}>
                <div className="content0">
                    <div className="title-wrapper">
                        <h1 className={"title"}><p>{title}&nbsp;</p></h1>
                        <h2 className={"feTitle"}><p>{feTitle}&nbsp;</p></h2>
                    </div>
                    <div className="text">
                        {/* <Col span={8}>
                            {
                                imgList && imgList.length > 0 && imgList.map((img) => {
                                    return (
                                        <img src={img.url}/>
                                    )
                                })
                            }
                        </Col>
                        <Col span={16}>
                            {
                                textList && textList.length > 0 && textList.map((text) => {
                                    return (
                                        <p className={"textP"}>{text}</p>
                                    )
                                })
                            }
                        </Col>*/}
                        <div>
                            {
                                textList && textList.length > 0 && textList.map((text, index) => {
                                    return (
                                        <p key={index} className={"textP"}>{text}</p>
                                    )
                                })
                            }
                        </div>
                        {!videoUrl && <div className={"imgCon"}>
                            {
                                imgList && imgList.length > 0 && imgList.map((img, index) => {
                                    return (
                                        <img key={index} src={img.url} />
                                    )
                                })
                            }
                        </div>}
                        {
                            videoUrl &&
                            <div className="images">
                                <video
                                    className="video-response"
                                    controls
                                    preload="auto"
                                    width="100%"
                                    height="450"


                                >
                                    <source src={videoUrl} type="video/mp4" />
                                </video>
                            </div>
                        }
                    </div>
                    <div className={"footer"}>
                        <Row>
                            <Col span={10}>
                                <p>
                                    <span className={"footerSpan"}>上一篇：</span>
                                    <a style={{ color: "rgba(0, 0, 0, 0.65)", }}
                                        onClick={this.changeInfo.bind(this, -1)}>{preInfo ? preInfo.title : "无"}</a>
                                </p>
                                <p>
                                    <span className={"footerSpan"}>下一篇：</span>
                                    <a style={{ color: "rgba(0, 0, 0, 0.65)", }}
                                        onClick={this.changeInfo.bind(this, 1)}>{fixInfo ? fixInfo.title : "无"}</a>
                                </p>
                            </Col>
                            <Col span={10}>
                            </Col>
                            <Col span={4}>
                                <Button type="primary" onClick={this.goBackClick.bind(this)}>返回</Button>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>

        )
    }
}

